import { orderBy } from 'lodash';

interface IAsset {
    category?: string;
    filename: string;
    id?: string;
    s3Id?: string;
}

interface IRequest {
    assets?: IAsset[];
    customControlData: any;
}

export function getPhotoAssetIdKey(volgnummer: string | number) {
    return `photo${volgnummer}AssetId`;
}

export function getPhotoAssetId(request: IRequest, volgnummer: string | number) {
    const photoAssetIdKey = getPhotoAssetIdKey(volgnummer);
    const photoAssetId = request.customControlData?.[photoAssetIdKey];

    return photoAssetId ? String(photoAssetId) : null;
}

export function isPhotoAssetIdKey(key: string) {
    return /^photo\d+AssetId$/.test(key);
}

export function getOrderedPhotoAssetIds(request: IRequest) {
    const photoAssetIdMatches = Object.keys(request.customControlData ?? {})
        .map((key) => key.match(/^photo(?<volgnummer>\d+)AssetId$/))
        .filter((match) => match && request.customControlData[match[0]])
        .map((match) => ({
            photoAssetId: String(request.customControlData[match![0]!]),
            volgnummer: parseInt(match!.groups!.volgnummer!, 10),
        }));

    return orderBy(photoAssetIdMatches, (match) => match.volgnummer);
}

export function getOrderedAssets(request: IRequest) {
    if (!request || !request.assets || request.assets.length === 0) {
        return [];
    }

    const orderedPhotoAssetIds = getOrderedPhotoAssetIds(request).map((photoAssetId) => photoAssetId.photoAssetId);

    return orderBy(request.assets, (asset) =>
        asset.id && orderedPhotoAssetIds.includes(asset.id) ? orderedPhotoAssetIds.indexOf(asset.id) : 1000
    );
}
